import premiumCTA from "@/assets/premium_cta.jpg";
import { Link } from "react-router-dom";

const premiumBenefits = [
  {
    icon: 'ri-award-line',
    title: 'Certificate of Participation',
    desc: 'Receive an official GNA certificate recognizing your commitment to AI-powered business growth.',
    color: 'from-amber-50 to-yellow-50',
    border: 'border-amber-200',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
  },
  {
    icon: 'ri-team-line',
    title: 'GNA AI Business Community',
    desc: 'Join an exclusive network of AI-forward business owners, founders, and growth leaders.',
    color: 'from-green-50 to-green-100',
    border: 'border-green-200',
    iconBg: 'bg-green-100',
    iconColor: 'text-green-700',
  },
  {
    icon: 'ri-medal-line',
    title: 'Discounted AI Powered Website/App Solutions',
    desc: 'Get exclusive discounts on AI Powered Website/App Solutions',
    color: 'from-emerald-50 to-green-50',
    border: 'border-emerald-200',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-700',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Post-Summit Implementation Session',
    desc: 'An exclusive follow-up session to help you implement what you learned — with expert guidance.',
    color: 'from-yellow-50 to-amber-50',
    border: 'border-yellow-200',
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-700',
  },
  {
    icon: 'ri-file-copy-line',
    title: 'AI Glossary Manual',
    desc: 'Access to downloadable AI manual - a great addition to your AI learning tools.',
    color: 'from-green-50 to-emerald-50',
    border: 'border-green-200',
    iconBg: 'bg-green-100',
    iconColor: 'text-green-700',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Priority AI Consulting Access',
    desc: 'Get priority access to GNA\'s AI consulting team for personalized business transformation support.',
    color: 'from-amber-50 to-yellow-50',
    border: 'border-amber-200',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
  },
];

const PremiumSection = () => {
  return (
    <section id="premium" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-green-50 border border-green-200 text-green-700 text-xs font-semibold uppercase tracking-widest mb-4">
            Premium Benefits
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            Move from Learning to
            <span className="bg-gradient-to-r from-green-700 to-green-600 bg-clip-text text-transparent"> Real Transformation</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Premium access is designed for serious business owners who want to go beyond the summit and implement AI strategies with expert support.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
          {premiumBenefits.map((b) => (
            <div
              key={b.title}
              className={`p-6 rounded-2xl bg-gradient-to-br ${b.color} border ${b.border} hover:-translate-y-1 transition-transform duration-200 cursor-default`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${b.iconBg} mb-4`}>
                <i className={`${b.icon} text-xl ${b.iconColor}`}></i>
              </div>
              <h4 className="font-bold text-gray-900 text-base mb-2">{b.title}</h4>
              <p className="text-gray-600 text-sm leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src={premiumCTA}
            alt="Premium CTA Background"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-green-800/92 to-green-700/88"></div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 px-8 md:px-12 py-12">
            <div className="text-center lg:text-left">
              <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-3">
                Ready to Transform Your Business?
              </h3>
              <p className="text-white/80 text-base max-w-lg">
                Join serious business owners who are investing in their AI future. Premium access is your fast-track to real implementation.
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-5">
                {['Certificate', 'Community', 'Templates', 'Consulting'].map((tag) => (
                  <span key={tag} className="px-3 py-1 rounded-full bg-white/20 text-white text-xs font-semibold whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="text-center shrink-0">
              <p className="text-white/70 text-sm mb-1">One-time investment</p>
              <p className="text-5xl font-extrabold text-white mb-4">$100</p>
              <Link
                to="/premium"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-block px-8 py-4 rounded-full bg-amber-400 text-green-900 font-bold text-base hover:bg-amber-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                Upgrade to Premium →
              </Link>
              <p className="text-white/60 text-xs mt-3">Available after free registration</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PremiumSection;
